import { Box, Checkbox, FormControlLabel, FormGroup, Menu, MenuItem, Typography, useMediaQuery } from '@mui/material'
import { useMenuCC } from 'hooks'
import React from 'react'
import { useTranslation } from 'react-i18next'
import TypographyEllipsis from 'components/common/Typography/TypographyEllipsis'
import theme from 'theme'
import { SearchCC } from 'components/common/SearchCC'
import { ButtonTriggerFilter } from 'components/common/Button'
import { LABEL_TYPE_MEETING, STATUS_MEETING } from '../hook/useManagerMeeting'

const FilterStatusMeeting = ({
    statusMeeting,
    handleUpdateStatusMeeting,
    roomName,
    setRoomName,
    handleSearchRoomName
}) => {
    const { t } = useTranslation()
    const isLargePC = useMediaQuery(theme.breakpoints.up('xl'))
    const { open, anchorEl, setAnchorEl } = useMenuCC()

    const renderListStatusMeeting = () => {
        let listStatus = ''
        statusMeeting.forEach((status, index) => {
            if (index !== statusMeeting.length - 1) {
                listStatus += t(LABEL_TYPE_MEETING[status]) + ', '
            } else listStatus += t(LABEL_TYPE_MEETING[status])
        })

        const widthTypo = !isLargePC ? '150px' : '250px'
        const conditionWidth = isLargePC ? statusMeeting.length > 3 : statusMeeting.length > 1

        return (
            <TypographyEllipsis sx={(theme) => ({ width: conditionWidth ? widthTypo : 'unset', fontWeight: 600, color: theme.palette.text.primary })}>
                {listStatus}
            </TypographyEllipsis>
        )
    }

    return (
        <Box display={'flex'} direction={'row'} alignItems={'center'} spacing={2.5}>
            <Typography sx={{ whiteSpace: 'nowrap', mr: 1 }}>{t('mnMeeting.status')}</Typography>
            <ButtonTriggerFilter id={'btn-filter-status-meeting'} open={open} setAnchorEl={setAnchorEl}
                label={((statusMeeting.length === Object.keys(STATUS_MEETING).length) || !statusMeeting.length) ? t('title.all') : renderListStatusMeeting()} />
            <Menu
                id="menu-status-meeting"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <FormGroup sx={{ display: 'flex', flexDirection: 'column' }}>
                    {
                        Object.values(STATUS_MEETING).map(type => (
                            <MenuItem key={type} sx={{ padding: `0 ${theme.spacing(2.5)}` }}>
                                <FormControlLabel key={type} onChange={(e) => handleUpdateStatusMeeting(e.target?.value, e.target?.checked)} control={<Checkbox checked={statusMeeting.includes(type)} />} label={t(LABEL_TYPE_MEETING[type])} value={type} />
                            </MenuItem>
                        ))
                    }
                </FormGroup>
            </Menu>
            <SearchCC backgroundColor={"#FFFF"} value={roomName} setValue={setRoomName} handleValue={handleSearchRoomName} />
        </Box>
    )
}

export default FilterStatusMeeting